function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.5082 1.21214C9.5082 1.88158 7.93752 2.42428 6 2.42428C4.06248 2.42428 2.4918 1.88158 2.4918 1.21214C2.4918 0.542693 4.06248 0 6 0C7.93752 0 9.5082 0.542693 9.5082 1.21214Z",
  fill: "#1BA58C"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M3.541 6.02606C1.45347 6.35129 0 7.07788 0 7.92205C0 9.06967 2.68629 10 6 10C9.31371 10 12 9.06967 12 7.92205C12 7.08285 10.5636 6.35987 8.49585 6.03186C7.77156 6.17674 6.93024 6.25969 6.03279 6.25969C5.12344 6.25969 4.27173 6.17453 3.541 6.02606Z",
  fill: "#1BA58C"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M4.05414 2.56877C2.32329 2.83153 1.11475 3.4285 1.11475 4.12284C1.11475 5.06007 3.31663 5.81983 6.03279 5.81983C8.74894 5.81983 10.9508 5.06007 10.9508 4.12284C10.9508 3.42317 9.72368 2.8224 7.97154 2.56281C7.40966 2.69494 6.73094 2.77217 6 2.77217C5.28017 2.77217 4.61097 2.69726 4.05414 2.56877Z",
  fill: "#1BA58C"
});

const SvgBalancerLogo = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBalancerLogo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/balancer-logo.21c038b4.svg";
export { ForwardRef as ReactComponent };